/***
 * Created on 2023/10/2
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";

function ContentLoader(props) {
    const { t } = useTranslation();

    return (
        <div className="comp-loading-indicator">
            <div className="loading-indicator--modern">
                <div className="loading-indicator__modern-wrapper">
                    <div className="loading-indicator__anime--circular">
                        <svg className="circular" viewBox="0 0 40 40">
                            <circle className="base" cx="20" cy="20" r="16" fill="none" strokeLinecap="round"
                                    strokeWidth="4" strokeMiterlimit="10"
                                    stroke="#e5e8eb"/>
                            <circle className="path" cx="20" cy="20" r="16" fill="none" strokeLinecap="round"
                                    strokeWidth="4"
                                    strokeMiterlimit="10" stroke="#001B49"/>
                        </svg>
                    </div>
                    <div className="loading-indicator__content !ml-4">
                        <div className="indicator--head !mb-0">
                            <span className="text">{t('@Updating@')}...</span>
                        </div>
                        <div className="indicator--detals">{t('@Fetching Contents Please Wait@')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContentLoader;